import { useEffect, useState } from 'react';
import { getInstructionalLevelById, updateInstructionalLevel } from '../../services/instructionalLevel/editInstructionalLevelService.js';
import { isNameValid, isDescriptionValid } from '../../utils/validations/instructionalLevelValidations.js';

const initialForm = {
    name: '',
    description: ''
};

export const useEditInstructionalLevel = (id) => {
    const [form, setForm] = useState(initialForm);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [validationErrors, setValidationErrors] = useState([]);

    useEffect(() => {
        const loadInstructionalLevel = async () => {
            try {
                const instructionalLevel = await getInstructionalLevelById(id);
                setForm({ ...initialForm, ...instructionalLevel });
            } catch (err) {
                setError(
                    err.response?.status === 404
                        ? 'Nivel instrucional no encontrado.'
                        : 'Error al obtener los datos del nivel instruccional.'
                );
            }
        };

        loadInstructionalLevel();
    }, [id]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const submit = async () => {
        if (!isNameValid(form.name)){
            setError('El nombre del nivel solo pueden contener letras.');
            return;
        }
        if (!isDescriptionValid(form.description)){
            setError('La descripción no puede contener caracteres especiales.');
            return;
        }
        // Si todo esta validado, procedimiento guardar
        try {
            await updateInstructionalLevel(id, {
                ...form
            });
            setSuccess('El nivel instrccional ha sido actualizado exitosamente.');
            setValidationErrors([]);
        } catch (err) {
            // Validación del archivo: middleware/validator.js del backend
            if (err.response?.status === 400 && Array.isArray(err.response.data?.errors)) {
                setValidationErrors(err.response.data.errors);
                return;
            }
            // Error general
            setError(
                err.response?.data?.error || 
                err.response?.data?.message || 
                'Error al actualizar el nivel instruccional.'
            );
        }
    }

    const clearMessages = () => {
        setError('');
        setSuccess('');
        setValidationErrors([]);
    };

    return {
        form,
        error,
        success,
        validationErrors,
        handleChange,
        submit,
        clearMessages
    };
}